const BOOKING_FAVORITES_ROOT = ["booking-favorites"] as const;

export const bookingFavoritesQueryKeys = {
  all: BOOKING_FAVORITES_ROOT,
  byFloor: (floorInventoryId: number) =>
    [...BOOKING_FAVORITES_ROOT, "by-floor", floorInventoryId] as const,
  vehicles: [...BOOKING_FAVORITES_ROOT, "vehicles"] as const
};
